import { Box, Typography } from '@mui/material';
import { formatCurrency } from '@utriper/core';
import { useTranslation } from 'react-i18next';

const Card = ({ title = '', value = 0, currency, align = 'center', displayShadow = true, displayBorder = true, width = { xs: '100%', sm: 'auto', lg: '100%' }, order = 2}) => {
    const { i18n } = useTranslation();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: align, gap: '8px', minWidth: 'fit-content', width, padding: '16px 24px', border: displayBorder ? 'solid 1px #13131340' : 'none', borderRadius: '8px', boxShadow: displayShadow ? 'var(--shadow-card)' : 'none' }}>
            <Typography fontSize="24px" fontWeight="bold" sx={{ color: '#137DC5', order }}>
                {currency ? formatCurrency(value, currency, i18n.language) : value}
            </Typography>
            <Typography fontSize="16px" fontWeight="bold" sx={{ color: '#131313bf', order: 1 }}>
                {title}
            </Typography>
        </Box>
    );
};

export default Card;
